import LoyaltyIcon from 'components/ReusableComponents/Arrivals/LoyaltyIcon'
import { getLoyaltyLevelText } from 'components/ReusableComponents/Arrivals/LoyaltyIcon/helpers'
import LoyaltyTooltip from 'components/ReusableComponents/Arrivals/LoyaltyTooltip'
import GuestIcon from 'components/ReusableComponents/Icons/Guest'
import { subscriptionStatusTypes } from 'features/Messaging/messaging-helpers'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { formatPhoneNumber } from 'utils/helpers'

import GuestDetailsButton from '../../components/ReusableComponents/GuestDetailsButton'
import styles from './BookingDetails.module.scss'

const Detail = ({ label, value, showLoyaltyTooltip }) => (
  <div className={styles.guestRow}>
    <div className={styles.guestLabel}>{label}</div>
    {label === 'Email' && showLoyaltyTooltip && <LoyaltyTooltip customText={value} />}
    <div className={styles.guestValue}>{value}</div>
  </div>
)

const unknownDate = '1978-09-12T00:00:00'
const GuestDetails = ({
  fullName,
  phone,
  email,
  loyaltyId,
  loyaltyLevel,
  loyaltyProgram,
  cityState,
  city,
  state,
  lastCheckOut,
  subscriptionStatus,
  subscriberId,
  onClose
}) => {
  const cityStateString = cityState?.length > 1 ? `${cityState}` : `${city}, ${state}`

  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)

  const loyaltyLevelText = getLoyaltyLevelText(parentChainCode, loyaltyLevel)
  const [showLoyaltyTooltip, setShowLoyaltyTooltip] = useState(false)

  return (
    <div className={styles.guestDetails}>
      <h3 className={styles.title}>
        {loyaltyLevel ? (
          <LoyaltyIcon
            loyaltyProgram={loyaltyProgram}
            loyaltyLevel={loyaltyLevel}
            className={styles.loyaltyIcon}
          />
        ) : (
          <GuestIcon
            style={{
              width: 21,
              height: 21,
              position: 'relative',
              marginRight: 10
            }}
          />
        )}{' '}
        {fullName}
      </h3>
      <div className={styles.guestDetailsCard}>
        <Detail label="Phone" value={formatPhoneNumber(phone)} />
        <div
          className={styles.guestRow}
          onMouseEnter={() => setShowLoyaltyTooltip(true)}
          onMouseLeave={() => setShowLoyaltyTooltip(false)}
        >
          <div className={styles.guestLabel}>Email</div>
          {showLoyaltyTooltip && <LoyaltyTooltip customText={email} />}
          <div className={styles.guestValue}>{email}</div>
        </div>

        {loyaltyLevel && <Detail label="Loyalty level" value={loyaltyLevelText} />}
        {loyaltyId && <Detail label="Loyalty id" value={loyaltyId} />}
        {cityState && <Detail label="City &amp; state" value={cityStateString} />}
        {!cityState && city && state && (
          <Detail label="City &amp; state" value={`${city}, ${state}`} />
        )}
        <Detail
          label="Last checkout"
          value={
            lastCheckOut === unknownDate
              ? 'Unknown'
              : moment(lastCheckOut).format('MMM DD, YYYY')
          }
        />
        <Detail label="Status" value={subscriptionStatusTypes[subscriptionStatus]} />
        {subscriberId && (
          <GuestDetailsButton subscriberId={subscriberId} onClose={onClose} />
        )}
      </div>
    </div>
  )
}

export default GuestDetails
